export class Environment {
  static getApiUrl(): string {
    return import.meta.env.VITE_API_URL;
  }
}